import * as React from 'react';
import { useQuery, Direction } from './Query';
import { FilterHeader } from './QueryTable';
import Modal, { ModalSize } from '../misc/components/modal';
import Select from 'react-select';

export interface Option {
    label: any;
    value: any;
}

interface OverreadStatusHeaderProps {
    title?: string;
    userOptions: Option[];
    usernameField?: string;
    automationId?: string;
}

export const OverreaderHeader = ({ title, userOptions, usernameField, automationId = null }: OverreadStatusHeaderProps) => {

    const [display, setDisplay] = React.useState(false);
    const { filters, ordering, applyOrdering } = useQuery();
    const [ordered, setOrdered] = React.useState<Direction>();
    const [filtered, setFiltered] = React.useState(false);
    title = title ?? "Over-reader";

    React.useEffect(() => {
        const filtered = filters.some(f => (f.field === 'analysisSets' && f.condition === 'any' && f.subQueryConditions?.find(sqc => sqc.value === usernameField)));
        setFiltered(filtered);
    }, [filters]);

    const handleFilter = () => {
        setDisplay(true);
    }

    const modal = display
        ? (
            <OverreaderFilterModal
                title={title}
                userOptions={userOptions}
                usernameField={usernameField}
                onClose={() => setDisplay(false)} />
        )
        : null;

    return (
        <>
            <FilterHeader automationId={automationId} filtered={filtered} sorted={ordered} onFilter={handleFilter} sortEnabled={false}>{title}</FilterHeader>
            {modal}
        </>
    );
}

interface OverreaderFilterModalProps {
    title?: string;
    userOptions: any[];
    usernameField: string;
    onClose: () => void;
}

export const OverreaderFilterModal = ({ title, userOptions, usernameField, onClose }: OverreaderFilterModalProps) => {

    const [userValues, setUserValues] = React.useState<any[]>([]);

    const { filters, applyFilters, paging, applyPaging } = useQuery();

    title = title ?? "Over-reader";

    const analysisSetsField = 'analysisSets', analysisSetsSubField = usernameField;

    React.useEffect(() => {
        const currentStatusValues = filters.filter(f => f.field === analysisSetsField && f.condition === 'any' && f.subQueryConditions?.find(sqc => sqc.value === usernameField)).flatMap(f => f.values);

        setUserValues(currentStatusValues);
    }, [filters]);


    const handleApply = () => {
        let newFilters = filters.filter(f => !(f.field === analysisSetsField
                && f.primarySubClauseField === analysisSetsSubField
                && f.subQueryConditions?.find(sqc => sqc.value === usernameField)));

        userValues && userValues.length > 0 && (newFilters = [...newFilters,
                {
                    field: analysisSetsField,
                    condition: 'any',
                    primarySubClauseField: analysisSetsSubField,
                    primarySubQueryCondition: 'eq',
                    values: userValues,
                    subQueryConditions: [
                        {
                            subClauseField: usernameField,
                            subCondition: 'eq',
                            value: userValues
                        },
                    ]
                }
            ]);

        applyPaging({ ...paging, page: 1 });
        applyFilters(newFilters);
        onClose();
    }

    const handleClear = () => {
        applyPaging({ ...paging, page: 1 });

        applyFilters(filters.filter(
            f =>
                (
                    f.field !== analysisSetsField
                )
                &&
                (
                    f.field !== usernameField
                )
        ));

        onClose();
    }

    return (
        <Modal header={`${title} Filter`} size={ModalSize.Normal} show={true} closeModalHandler={onClose}>
            <div className="modal-body">
                <label>Status</label>
                <Select
                    id="overread-status-match"
                    name="match1"
                    isMulti={true}
                    classNamePrefix="multiSelect"
                    options={userOptions}
                    autoFocus={true}
                    value={userValues.map(v => userOptions.find(o => o.value === v))}
                    getOptionLabel={o => o.label}
                    getOptionValue={o => o.value}
                    onChange={(o: any[]) => setUserValues(o.map(v => v.value))}
                />
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleApply} data-automationid="submit-filter">OK</button>
                <button className="btn btn-danger" onClick={handleClear} data-automationid="clear-filter">Clear</button>
            </div>
        </Modal>
    );
};
